import { gql } from '@apollo/client';

export const LONG_TRANSACTION_FIELDS_FRAGMENT = gql`
  fragment LongTransactionFields on LongTransaction {
    responseType
    refundAmount
    messageBody
  }
`;
